import React, { useCallback } from 'react';
import { observer } from 'mobx-react';

import { useStore } from 'core/store/';
import { OfferPageTabs } from 'core/store/offer-store';
import { useToast } from 'core/components/toast';
import { Discount } from '../discount';

const GoodStudent = ({ ...discount }) => {
  const { offer: store } = useStore();
  const toast = useToast();

  const onAddClick = useCallback(() => {
    if (store.currentTab !== OfferPageTabs.PEOPLE) {
      store.setCurrentTab(OfferPageTabs.PEOPLE);
    }
    store.setScrollTo('drivers');
    store.setUiHelpers({ eligibleStudentDriversCardsOpen: true });
    toast.notify({
      type: 'success',
      message: 'Identify eligible drivers who are full-time students to apply the good student discount.'
    });
  }, [store, toast]);

  return <Discount {...discount} onAdd={onAddClick} />;
};

export default observer(GoodStudent);
